var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSatchel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 50,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.078 73.756h-5.81V45.988M71.84 73.756h5.809V45.988M61.578 73.756H37.622M30.864 32.697H20.359V45.74l5.164.664c1.778.231 3.556.421 5.34.605",
  stroke: "#5C6471",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.053 47.014a201.24 201.24 0 0 0 5.341-.605l5.164-.664V32.697H69.053M34.77 47.346c9.87.788 19.789.812 29.665.071M64.43 32.697H34.77",
  stroke: "#5C6471",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.77 53.707V30.788h-3.823v22.919M30.947 57.525v17.191h3.823V57.525",
  stroke: "#A4ABB7",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.666 53.707h-5.608v3.818h5.608v-3.818Z",
  stroke: "#F15B35",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.253 53.707V30.788h-3.824v22.919M64.43 57.525v17.191h3.823V57.525",
  stroke: "#A4ABB7",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M69.142 53.707h-5.608v3.818h5.608v-3.818Z",
  stroke: "#F15B35",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.408 28.88a8.594 8.594 0 0 1 8.596-8.596A8.594 8.594 0 0 1 57.6 28.88M40.408 31.02v1.677M57.6 31.02v1.677",
  stroke: "#5C6471",
  strokeWidth: 1.186,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSatchel;